import axios from 'axios';

import { Author } from './Author';

/**
 * Representation of an AuthorRecommendation object returned from the API.
 */
export interface AuthorRecommendation {
    simTask: Author[];
    simMethod: Author[];
    simspecter: Author[];
    simTask_distMethod: Author[];
    simMethod_distTask: Author[];
}

export interface AuthorName {
    id: number;
    name: string;
    externalIds?: any;
    affiliations?: string[];
    paperCount?: number;
    citationCount?: number;
    hIndex?: number;
}

export function getAuthorRecommendations(id: string, year: string): Promise<AuthorRecommendation> {
    return axios
        .get(`/api/get_recs/${id}`, { params: { year: year } })
        .then((response) => response.data);
}
